import { memo, type ReactNode } from "react"
import { BrackyReplyBubble } from "./components/BrackyReplyBubble"
import { MessageBubble } from "./components/MessageBubble"

type UserExchangeMockUpProps = {
  userMessage: string
  brackyMessage: string
  username: string
  userTimestamp: string
  brackyTimestamp: string
  description?: ReactNode
  showDescriptionOnMobile?: boolean
}

export const LandingSectionBrackyMessage = memo(function LandingSectionBrackyMessage({
  userMessage,
  brackyMessage,
  username,
  userTimestamp,
  brackyTimestamp,
  description,
  showDescriptionOnMobile = false,
}: UserExchangeMockUpProps) {
  return (
    <div className="relative w-full sm:w-full max-w-none sm:max-w-md md:max-w-lg lg:max-w-none flex flex-col space-y-3 sm:space-y-4 mx-auto lg:mx-0 min-h-80">
      {/* Conversation Container */}
      <div className="flex flex-col gap-[0.65rem] sm:gap-[0.9rem]">
        {/* User message */}
        <MessageBubble
          username={username}
          message={userMessage}
          timestamp={userTimestamp}
          stats={{ comments: 1, retweets: 0, likes: 1 }}
          isUser={true}
        />

        {/* Bracky's reply */}
        <BrackyReplyBubble
          message={brackyMessage}
          timestamp={brackyTimestamp}
          stats={{ comments: 3, retweets: 2, likes: 5 }}
        />
      </div>

      {/* Description for mobile */}
      {showDescriptionOnMobile && description && (
        <div className="lg:hidden max-w-[95%] sm:max-w-md mx-auto -mt-2 text-center pl-2 pr-4">
          <div className="text-white/70 text-[0.9375rem] sm:text-[1.0625rem] leading-[1.43] md:mb-2 mdlg:mb-3 lg:mb:0">
            {description}
          </div>
        </div>
      )}
    </div>
  )
})
